import { Flex, Statistic } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SegmentedOrDropdown, ShrinkingButton, StatCard } from "~/components";
import { COLORS, convertCurrencyFromLowest, formatMoney } from "~/utils";

export type RentDueHomeStatCardProps = {
  neverPaidCount: number;
  inProgressCount: number;
  neverPaidBalanceDue: number;
  inProgressBalanceDue: number;
  month: number;
  year: number;
  verySmallScreen: boolean;
};

export const RentDueHomeStatCard = ({
  neverPaidCount,
  inProgressCount,
  neverPaidBalanceDue,
  inProgressBalanceDue,
  month,
  year,
  verySmallScreen,
}: RentDueHomeStatCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [rentDueTab, setRentDueTab] = useState(0);

  const tabOptions = [t("Rent_Not_Submitted"), t("Rent_In_Progress")];
  const counts = [neverPaidCount, inProgressCount];
  const balances = [neverPaidBalanceDue, inProgressBalanceDue];
  const selectedCount = counts[rentDueTab];
  const selectedBalance = balances[rentDueTab];
  const isNeverPaidTab = rentDueTab === 0;
  const showDanger = isNeverPaidTab && neverPaidCount > 0;

  const handleViewFinance = () => {
    navigate(`/finance?year=${year}&month=${month}`);
  };

  return (
    <StatCard
      title={t("Rent_Due")}
      description={t("Rent_Due_home_description")}
      style={
        showDanger
          ? {
              borderColor: COLORS.red,
              boxShadow: `0 0 0 1px ${COLORS.red}22`,
            }
          : undefined
      }
      action={
        <SegmentedOrDropdown
          items={tabOptions}
          selected={rentDueTab}
          setSelected={setRentDueTab}
          useDropdown={verySmallScreen}
        />
      }
    >
      <Flex style={{ flexWrap: "wrap", alignItems: "flex-end", gap: 8 }}>
        <Statistic
          value={selectedCount}
          valueStyle={
            showDanger ? { color: COLORS.crimson_red } : { color: COLORS.baby_blue }
          }
        />
        {selectedCount > 0 && (
          <Statistic
            value={convertCurrencyFromLowest(selectedBalance)}
            formatter={(val) => formatMoney(Number(val))}
            valueStyle={{
              fontSize: 16,
              color: showDanger ? COLORS.crimson_red : COLORS.baby_blue,
            }}
          />
        )}
        <ShrinkingButton
          small={verySmallScreen}
          onClick={handleViewFinance}
          type="primary"
          danger={showDanger}
          style={{ marginLeft: "auto" }}
        >
          {t("Details")}
        </ShrinkingButton>
      </Flex>
    </StatCard>
  );
};
